import React from "react";
import buycoffee from "../assets/portfolio/buycoffee.jpg";
import dex from "../assets/portfolio/dex.jpg";
import weatherapp from "../assets/portfolio/weatherapp.jpg";
import bloodbank from "../assets/portfolio/bloodbank.jpg";
import healthinsurance from "../assets/portfolio/healthinsurance.jpg";
import diabeiiesprediction from "../assets/portfolio/diabeiiesprediction.jpeg";
import Lipnet from "../assets/portfolio/Lipnet.jpeg";
import MovieRecommendation from "../assets/portfolio/MovieRecommendation.png";
import chatwithmysql from "../assets/portfolio/chatwithmysql.png";
import heartDiseasePrediction from "../assets/portfolio/heartDiseasePrediction.jpeg";
import pdf_chat_llm from "../assets/portfolio/pdf_chat_llm.png";
import ai_agent_dat_analyst from "../assets/portfolio/ai_agent_dat_analyst.png";

const portfolioItems = [
  {
    image: ai_agent_dat_analyst,
    alt: "AI Agent Data Analyst",
    demo: "https://huggingface.co/spaces/DebabrataHalder/AI-AGENT-Data-Analyst-Debabrata",
    code: "https://github.com/DebabrataHalder/AI-Agent-Data-Analyst",
  },
  {
    image: pdf_chat_llm,
    alt: "PDF Chat LLM",
    demo: "https://huggingface.co/spaces/DebabrataHalder/chatWithMultiplePDF1",
    code: "https://github.com/DebabrataHalder/chatWithMultiplePDFs",
  },
  {
    image: chatwithmysql,
    alt: "Chat with MySQL",
    demo: "https://inventory-dashboard-with-mysqlchat.onrender.com/",
    code: "https://github.com/DebabrataHalder/Inventory_dashboard_with_mysqlChat",
  },
  {
    image: MovieRecommendation,
    alt: "Movie Recommendation",
    demo: "https://cinema-recommendation-sys.streamlit.app/",
    code: "https://github.com/DebabrataHalder/cosine-recommendation-system",
  },
  {
    image: heartDiseasePrediction,
    alt: "Heart Disease Prediction",
    demo: null,
    code: "https://github.com/DebabrataHalder/Heart-disease-Prediction",
  },
  {
    image: diabeiiesprediction,
    alt: "Diabetes Prediction",
    demo: null,
    code: "https://github.com/DebabrataHalder/Logistic-regression-model-from-scratch-Diabetes-prediction-",
  },
  {
    image: Lipnet,
    alt: "LipNet",
    demo: null,
    code: "https://github.com/DebabrataHalder/lipSyncToText",
  },
  {
    image: buycoffee,
    alt: "Buy Coffee",
    demo: "https://debabratabuymeacoffee.netlify.app/",
    code: "https://github.com/DebabrataHalder/buyMeCoffee",
  },
  {
    image: dex,
    alt: "Dex",
    demo: "https://debabratadex.netlify.app/",
    code: null,
  },
  {
    image: bloodbank,
    alt: "bloodbank",
    demo: "https://github.com/DebabrataHalder/bloodbankSmartContract",
    code: null,
  },
  {
    image: healthinsurance,
    alt: "healthinsurance",
    demo: "https://github.com/DebabrataHalder/p2phealthinsurance",
    code: null,
  },
  {
    image: weatherapp,
    alt: "weatherapp",
    demo: "https://debabrataweather.netlify.app/",
    code: "https://github.com/DebabrataHalder/currentWeatherApp",
  },
];

const Portfolio = () => {
  return (
    <div
      name="portfolio"
      className="bg-gradient-to-b from-black to-gray-800 h-auto w-full text-white md:h-auto"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-auto">
        <div className="pt-36 pb-8">
          <p
            style={{ fontFamily: "'Orbitron', sans-serif" }}
            className="text-4xl font-bold inline border-b-4 border-gray-500"
          >
            Portfolio
          </p>
          <p style={{ fontFamily: "sans-serif" }} className="py-6">
            Check out some of my work right here
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {portfolioItems.map(({ image, alt, demo, code }, index) => (
            <div key={index} className="shadow-md shadow-gray-600 rounded-lg">
              <img
                src={image}
                alt={alt}
                className="rounded-md duration-200 hover:scale-105"
              />
              <div className="flex items-center justify-center">
                {demo && (
                  <a href={demo} target="_blank" rel="noreferrer">
                    <button
                      className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105"
                      style={{ fontFamily: "sans-serif" }}
                    >
                      Demo
                    </button>
                  </a>
                )}
                {code && (
                  <a href={code} target="_blank" rel="noreferrer">
                    <button
                      className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105"
                      style={{ fontFamily: "sans-serif" }}
                    >
                      Code
                    </button>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;